import React, { useState } from "react";
import NgoLayout from "../../../../layouts/Ngo/NgoLayout";
import '../../../../assets/css/Ngo/controlpanelCSS/DonationTracking.css';
import { FileCheck, Clock, CheckCircle, Ban, Package, AlertCircle } from "lucide-react";
const DonationTrackingDashboard = () => {
  const [selectedProof, setSelectedProof] = useState(null);

  // Stats Data
  const stats = [
    { 
      label: 'Total Donations Received', 
      amount: '1,20,000',
      icon: '💰',
      color: 'primary'
    },
    { 
      label: 'Direct Donations', 
      amount: '80,000',
      icon: '🎯',
      color: 'success'
    },
    { 
      label: 'Distributed Amount', 
      amount: '75,000',
      icon: '📤',
      color: 'info'
    },
    { 
      label: 'Remaining Balance', 
      amount: '45,000',
      icon: '💳',
      color: 'warning'
    }
  ];

  // Donation Method Breakdown
  const donationMethods = [
    { method: 'EasyPaisa', amount: '25,000', percentage: 51 },
    { method: 'JazzCash', amount: '14,000', percentage: 29 },
    { method: 'Bank Transfer', amount: '10,000', percentage: 20 }
  ];

  // Case Funding Progress
  const caseFunding = [
    { 
      student: 'Ayesha Khan', 
      required: '50,000', 
      received: '38,500',
      percentage: 77, 
      status: '77% Funded',
      statusType: 'warning',
      method: 'EasyPaisa' 
    },
    { 
      student: 'Ali Raza', 
      required: '30,000', 
      received: '12,000',
      percentage: 40, 
      status: 'Partially Funded',
      statusType: 'danger',
      method: 'JazzCash' 
    },
    { 
      student: 'Sara Ahmed', 
      required: '40,000', 
      received: '40,000',
      percentage: 100, 
      status: 'Fully Funded',
      statusType: 'success',
      method: 'Bank Transfer' 
    }
  ];

  // Donation History
  const donationHistory = [
    { 
      id: 1,
      date: '12 Apr', 
      donor: 'Ahmed', 
      student: 'Ayesha', 
      amount: '1,500',
      method: 'EasyPaisa',
      hasProof: true
    },
    { 
      id: 2,
      date: '13 Apr', 
      donor: 'Fatima', 
      student: 'Ali Raza', 
      amount: '2,000',
      method: 'JazzCash',
      hasProof: true
    },
    { 
      id: 3,
      date: '14 Apr', 
      donor: 'Hassan', 
      student: 'Sara Ahmed', 
      amount: '5,000',
      method: 'Bank Transfer',
      hasProof: true
    }
  ];

  // Disbursement Tracking
  const disbursements = [
    { 
      date: '14 Apr', 
      student: 'Ayesha', 
      amount: '38,500',
      method: 'EasyPaisa',
      status: 'Sent',
      statusType: 'success'
    },
    { 
      date: '15 Apr', 
      student: 'Ali Raza', 
      amount: '12,000',
      method: 'JazzCash',
      status: 'Pending',
      statusType: 'warning'
    },
    { 
      date: '16 Apr', 
      student: 'Sara Ahmed', 
      amount: '40,000',
      method: 'Bank Transfer',
      status: 'Sent',
      statusType: 'success'
    }
  ];

  // Handle view proof
  const handleViewProof = (donationId) => {
    setSelectedProof(donationId);
    alert(`Viewing proof for donation ID: ${donationId}`);
  };

  return (
    <NgoLayout>
      <div className="dtd-container">
        <div className="dtd-wrapper">
          {/* Header */}
          <div className="dtd-header">
            <h1 className="dtd-title">Donation Tracking Dashboard</h1>
          </div>
   <div className="ngd-section">
        <div className="ngd-card">
          <div className="ngd-card-header">
            <div>
              <h1 className="ngd-card-title">Distribution Summary</h1>
              <p className="ngd-card-subtitle">Fund flow and audit status</p>
            </div>
          </div>
          
          <div className="ngd-summary-grid">
            <div className="ngd-summary-item">
              <div className="ngd-summary-icon ngd-icon-received">
                <FileCheck size={20} />
              </div>
              <div className="ngd-summary-content">
                <span className="ngd-summary-label">Total Funds Received</span>
                <span className="ngd-summary-value">PKR 2.85M</span>
              </div>
            </div>
            
            <div className="ngd-summary-item">
              <div className="ngd-summary-icon ngd-icon-distributed">
                <Package size={20} />
              </div>
              <div className="ngd-summary-content">
                <span className="ngd-summary-label">Successfully Distributed</span>
                <span className="ngd-summary-value">PKR 2.10M</span>
              </div>
            </div>
            
            <div className="ngd-summary-item">
              <div className="ngd-summary-icon ngd-icon-pending">
                <Clock size={20} />
              </div>
              <div className="ngd-summary-content">
                <span className="ngd-summary-label">Pending Distribution</span>
                <span className="ngd-summary-value">PKR 750K</span>
              </div>
            </div>
            
            <div className="ngd-summary-item">
              <div className="ngd-summary-icon ngd-icon-proof">
                <AlertCircle size={20} />
              </div>
              <div className="ngd-summary-content">
                <span className="ngd-summary-label">Proof Upload Pending</span>
                <span className="ngd-summary-value">5 Cases</span>
              </div>
            </div>
          </div>
        </div>
      </div> 
    
          {/* Two Column Layout */}
          <div className="dtd-grid-2col">
            {/* Donation Method Breakdown */}
            <div className="dtd-card">
              <h2 className="dtd-card-title">Donation Method Breakdown</h2>
              <div className="dtd-method-table">
                <div className="dtd-method-header">
                  <div>Method</div>
                  <div>Amount</div>
                </div>
                {donationMethods.map((method, index) => (
                  <div key={index} className="dtd-method-row">
                    <div className="dtd-method-name">
                      <span className="dtd-method-icon">
                        {method.method === 'EasyPaisa' ? '📱' : 
                         method.method === 'JazzCash' ? '💸' : '🏦'}
                      </span>
                      {method.method}
                    </div>
                    <div className="dtd-method-amount">{method.amount}</div>
                    <div className="dtd-method-bar">
                      <div 
                        className="dtd-method-bar-fill"
                        style={{ width: `${method.percentage}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div> 

            {/* Case Funding Progress */}
            <div className="dtd-card">
              <h2 className="dtd-card-title">Case Funding Progress</h2>
              <div className="dtd-funding-table">
                <div className="dtd-funding-header">
                  <div>Student</div>
                  <div>Required</div>
                  <div>Received</div>
                  <div>Status</div>
                  <div>Method</div>
                </div>
                {caseFunding.map((item, index) => (
                  <div key={index} className="dtd-funding-row">
                    <div className="dtd-funding-student">{item.student}</div>
                    <div className="dtd-funding-required">{item.required}</div>
                    <div className="dtd-funding-received">{item.received}</div>
                    <div className="dtd-funding-status">
                      <div className="dtd-progress-bar">
                        <div 
                          className={`dtd-progress-fill dtd-progress-${item.statusType}`}
                          style={{ width: `${item.percentage}%` }}
                        ></div>
                      </div>
                      <span className={`dtd-status-text dtd-status-${item.statusType}`}>
                        {item.status}
                      </span>
                    </div>
                    <div className="dtd-funding-method">{item.method}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Donation History - Full Width */}
          <div className="dtd-card">
            <h2 className="dtd-card-title">Donation History</h2>
            <div className="dtd-table-responsive">
              <table className="dtd-table">
                <thead>
                  <tr className="dtd-table-header">
                    <th>Date</th>
                    <th>Donor</th>
                    <th>Student</th>
                    <th>Amount</th>
                    <th>Method</th>
                    <th>Proof</th>
                  </tr>
                </thead>
                <tbody>
                  {donationHistory.map((donation) => (
                    <tr key={donation.id} className="dtd-table-row">
                      <td>{donation.date}</td>
                      <td>{donation.donor}</td>
                      <td>{donation.student}</td>
                      <td className="dtd-amount">{donation.amount}</td>
                      <td>
                        <span className="dtd-method-badge">{donation.method}</span>
                      </td>
                      <td>
                        <button 
                          className="dtd-btn-view"
                          onClick={() => handleViewProof(donation.id)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Disbursement Tracking - Full Width */}
          <div className="dtd-card">
            <h2 className="dtd-card-title">Disbursement Tracking</h2>
            <div className="dtd-table-responsive">
              <table className="dtd-table">
                <thead>
                  <tr className="dtd-table-header">
                    <th>Date</th>
                    <th>Student</th>
                    <th>Amount</th>
                    <th>Method</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {disbursements.map((item, index) => (
                    <tr key={index} className="dtd-table-row">
                      <td>{item.date}</td>
                      <td>{item.student}</td>
                      <td className="dtd-amount">{item.amount}</td>
                      <td>
                        <span className="dtd-method-badge">{item.method}</span>
                      </td>
                      <td>
                        <span className={`dtd-status-badge dtd-badge-${item.statusType}`}>
                          {item.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </NgoLayout>
  );
};

export default DonationTrackingDashboard;